import * as ORDER_API from '@/api/order'

export default {
  state: {
    orderList: {
      data: [],
      meta: {},
      links: {}
    },
    orderData: null,
    orderItems: {}
  },
  mutations: {
    setOrderData (state, orderData) {
      state.orderData = orderData
    },
    updateOrderData (state, orderData) {
      state.orderData = { ...orderData }
    },
    setOrderList (state, orderList) {
      state.orderList = orderList
    },
    removeOrder (state, orderId) {
      if (state.orderList.data && state.orderList.data.length > 0) {
        let ind = _.findIndex(state.orderList.data, { id: orderId })
        if (ind >= 0) {
          state.orderList.data.splice(ind, 1)
        }
      }
    },
    setOrderItems (state, items) {
      state.orderItems = items
    },
    setOrderItemData (state, { itemId, itemData }) {
      const itemIndex = _.findIndex(state.orderItems, { id: itemId })
      state.orderItems.splice(itemIndex, 1, itemData)
    },
    removeOrderItem (state, itemId) {
      const itemIndex = _.findIndex(state.orderItems, { id: itemId })
      state.orderItems.splice(itemIndex, 1)
    },
    addOrderItem (state, itemData) {
      state.orderItems.push(itemData)
    }
  },
  getters: {
    orderList (state) {
      return state.orderList
    },
    orderData (state) {
      return state.orderData
    },
    orderItemsByOrder: (state) => (orderId) => {
      return _.filter(state.orderItems, { itemable_type: 'order', itemable_id: orderId })
    }
  },
  actions: {
    createOrder ({ commit }, attributes) {
      return ORDER_API.createOrder(attributes).then(resp => {
        commit('setOrderData', resp.data)
        return resp
      })
    },
    getOrders ({ commit }, params) {
      return ORDER_API.getOrders(params).then(resp => {
        commit('setOrderList', resp.data)
        return resp
      })
    },
    getOrder ({ commit }, orderId) {
      return ORDER_API.getOrder(orderId).then(resp => {
        commit('setOrderData', resp.data)
        return resp
      })
    },
    updateOrder ({ commit }, { orderId, attributes }) {
      return ORDER_API.updateOrder(orderId, attributes).then(resp => {
        commit('updateOrderData', resp.data)
        return resp
      })
    },
    deleteOrder ({ commit }, orderId) {
      return ORDER_API.deleteOrder(orderId).then(resp => {
        commit('removeOrder', orderId)
        return resp
      })
    },
    getOrderItems ({ commit }, orderId) {
      return ORDER_API.getOrderItems(orderId).then(resp => {
        commit('setOrderItems', resp.data)
        return resp
      })
    },
    updateOrderItem ({ commit }, { orderItemId, attributes }) {
      return ORDER_API.updateOrderItem(orderItemId, attributes).then(resp => {
        commit('setOrderItemData', { itemId: orderItemId, itemData: resp.data })
        return resp
      })
    },
    deleteOrderItem ({ commit }, itemId) {
      return ORDER_API.removeOrderItem(itemId).then(resp => {
        commit('removeOrderItem', itemId)
        return resp
      })
    },
    addOrderItem ({ commit }, { orderId, attributes }) {
      return ORDER_API.addOrderItem(orderId, attributes).then(resp => {
        commit('addOrderItem', resp.data)
        return resp
      })
    },
    createOrderFromQuote({ commit }, quoteId) {
      return ORDER_API.createOrderFromQuote(quoteId)
    },
    sendOrderToERP({ commit }, orderId) {
      return ORDER_API.sendOrderToERP(orderId)
    },
    sendOrderToQBO({ commit }, orderId) {
      return ORDER_API.sendOrderToQBO(orderId)
    },
    createOrderChangeRecord({ commit }, { orderId, data }) {
      return ORDER_API.createOrderChangeRecord(orderId, data)
    },
    getOrderChangeRecords({ commit }, orderId) {
      return ORDER_API.getOrderChangeRecords(orderId)
    },
    getOrderChangeRecordItems({ commit }, recordId) {
      return ORDER_API.getOrderChangeRecordItems(recordId)
    },
    updateOrderChangeRecord({ commit }, { recordId, data }) {
      return ORDER_API.updateOrderChangeRecord(recordId, data)
    },
    deleteOrderChangeRecordItem({ commit }, { itemId }) {
      return ORDER_API.deleteOrderChangeRecordItem(itemId)
    },
    createOrderChangeRecordAsQuote({ commit }, recordId) {
      return ORDER_API.createQuoteFromOrderChangeRecord(recordId)
    },
    getErpOrder({ commit }, orderId) {
      return ORDER_API.getErpOrder(orderId)
    },
    getErpPrepays({ commit }, orderId) {
      return ORDER_API.getErpOrderPrepays(orderId)
    }
  }
}
